import PhoneIcon from './PhoneIcon';
export default PhoneIcon;
